import React from 'react';
import { Button } from 'react-bootstrap';

const ErrorFallback = ({ onReset }) => {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', padding: '20px' }}>
            <h2>Something went wrong</h2>
            <p style={{ color: '#6c757d', marginBottom: '20px' }}>An unexpected error occurred. Please try refreshing the page.</p>
            <Button variant="outline-primary" onClick={onReset}>Try Again</Button>
        </div>
    );
};

export default ErrorFallback;
